import cx from 'classnames'
import dayjs from 'dayjs'

import { nodes, StrongNode } from 'prose-core'

import { JiraIssue } from './types'
import { ReactComponent as UnassignedIcon } from './icons/unassigned.svg'
import { AnchorOrDiv, Skel } from '../EmbedCommon/common'

import Styles from './JiraIssueFrame.module.scss'
import { jiraIssueUrl, jiraProjectsUrl, jiraProjectUrl } from './utils'
import { times } from 'lodash'
import dompurify from 'dompurify'
import textile from 'textile-js'

export const JiraIssueFrame = ({
  node,
  isLoading,
  data,
  preview,
}: {
  node: StrongNode<typeof nodes.jira_embed>
  isLoading: boolean
  data?: JiraIssue
  preview?: true
}) => {
  return (
    <div className={cx(Styles.wrapper, { [Styles.isLoading]: isLoading })}>
      {/* Project breadcrumbs */}
      <div className={Styles.breadcrumbs}>
        {isLoading ? (
          <>
            <Skel width="50%" />
          </>
        ) : (
          <>
            <AnchorOrDiv
              link={preview ? undefined : jiraProjectsUrl(node.attrs.link)}
              className={Styles.breadcrumbItem}
            >
              Projects
            </AnchorOrDiv>
            <div className={Styles.divider}>{' / '}</div>
            <AnchorOrDiv
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              link={preview ? undefined : jiraProjectUrl(node.attrs.link, data!.fields.project.key)}
              className={Styles.breadcrumbItem}
            >
              <img
                className={Styles.icon}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                src={data!.fields.project.avatarUrls['16x16']}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                alt={`Project ${data!.fields.project.name} Icon`}
                height="16px"
                width="16px"
              />
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
              {data!.fields.project.name}
            </AnchorOrDiv>

            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
            {data!.fields.parent && (
              <>
                <div className={Styles.divider}>{' / '}</div>

                <AnchorOrDiv
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  link={preview ? undefined : jiraIssueUrl(node.attrs.link, data!.fields.parent.key)}
                  className={Styles.breadcrumbItem}
                >
                  <img
                    className={Styles.icon}
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    src={data!.fields.parent.fields.issuetype.iconUrl}
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    alt={`${data!.fields.parent.fields.summary} Icon`}
                    height="16px"
                    width="16px"
                  />
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                  {data!.fields.parent.fields.summary}
                </AnchorOrDiv>
              </>
            )}
            <div className={Styles.divider}>{' / '}</div>
            <AnchorOrDiv
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              link={preview ? undefined : jiraIssueUrl(node.attrs.link, data!.key)}
              className={Styles.breadcrumbItem}
            >
              <img
                className={Styles.icon}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                src={data!.fields.issuetype.iconUrl}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                alt={`Issue ${data!.key} Icon`}
                height="16px"
                width="16px"
              />
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
              {data!.key}
            </AnchorOrDiv>
          </>
        )}
      </div>

      {/* Title */}
      <AnchorOrDiv link={preview ? undefined : node.attrs.link} className={Styles.title}>
        {isLoading ? (
          <>
            <Skel width={'75%'} height={'28px'} />
          </>
        ) : (
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          <>{data!.fields.summary}</>
        )}
      </AnchorOrDiv>

      {/* Status & description */}
      <div className={Styles.summary}>
        {isLoading || !data ? (
          <>
            <div className={cx(Styles.status, Styles.isLoading)}>
              <Skel width="79px" height="32px" />
            </div>

            <div className={cx(Styles.description, Styles.isLoading)}>
              <div className={Styles.sectionTitle}>
                <Skel width="79px" height="20px" />
              </div>

              <Skel width="100%" height="20px" />
              <Skel width="100%" height="20px" />
              <Skel width="100%" height="20px" />
              <Skel width="100%" height="20px" />
            </div>
          </>
        ) : (
          <>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
            <div className={cx(Styles.status, Styles[data!.fields.status.statusCategory.key])}>
              {data.fields.status.name}
            </div>
            <div className={Styles.description}>
              <div className={Styles.sectionTitle}>Description</div>

              <div
                className={Styles.descriptionBody}
                dangerouslySetInnerHTML={{
                  __html: data.fields.description ? dompurify.sanitize(textile(data.fields.description)) : '',
                }}
              />
            </div>
          </>
        )}
      </div>

      {/* Details */}
      <div className={Styles.details}>
        {isLoading ? (
          <>
            <div className={cx(Styles.sectionTitle, Styles.isLoading)}>
              <Skel width="47px" height="20px" />
            </div>

            <div className={cx(Styles.detailsTable, Styles.isLoading)}>
              <div className={Styles.column1}>
                {times(3, () => {
                  return (
                    <div className={Styles.row}>
                      <div className={Styles.tableLabel}>
                        <Skel width="52px" />
                      </div>

                      <div className={Styles.value}>
                        <Skel width="140px" height="28px" />
                      </div>
                    </div>
                  )
                })}
              </div>

              <div className={Styles.column2}>
                {times(2, () => {
                  return (
                    <div className={Styles.row}>
                      <div className={Styles.tableLabel}>
                        <Skel width="52px" />
                      </div>

                      <div className={Styles.value}>
                        <Skel width="140px" />
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        ) : (
          !preview && (
            <>
              <div className={Styles.sectionTitle}>Details</div>

              <div className={Styles.detailsTable}>
                <div className={Styles.column1}>
                  <div className={Styles.row}>
                    <div className={Styles.tableLabel}>Assignee</div>
                    <div className={Styles.value}>
                      {data?.fields.assignee ? (
                        <>
                          <img
                            className={cx(Styles.icon, Styles.avatar)}
                            // TODO: Fix this the next time the file is edited.
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            src={data!.fields.assignee.avatarUrls['24x24']}
                            alt="Assignee Avatar"
                            height="24px"
                            width="24px"
                          />

                          {/* TODO: Fix this the next time the file is edited. */}
                          {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                          {data!.fields.assignee.displayName}
                        </>
                      ) : (
                        <>
                          <UnassignedIcon className={cx(Styles.icon, Styles.unassignedIcon, Styles.avatar)} />
                          Unassigned
                        </>
                      )}
                    </div>
                  </div>

                  <div className={Styles.row}>
                    <div className={Styles.tableLabel}>Reporter</div>
                    <div className={Styles.value}>
                      <img
                        className={cx(Styles.icon, Styles.avatar)}
                        // TODO: Fix this the next time the file is edited.
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        src={data!.fields.reporter.avatarUrls['24x24']}
                        alt="Reporter Avatar"
                        height="24px"
                        width="24px"
                      />

                      {/* TODO: Fix this the next time the file is edited. */}
                      {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                      {data!.fields.reporter.displayName}
                    </div>
                  </div>

                  <div className={Styles.row}>
                    <div className={Styles.tableLabel}>Priority</div>
                    <div className={Styles.value}>
                      <img
                        className={Styles.icon}
                        // TODO: Fix this the next time the file is edited.
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        src={data!.fields.priority.iconUrl}
                        alt="Priority Icon"
                        height="16px"
                        width="16px"
                      />

                      {/* TODO: Fix this the next time the file is edited. */}
                      {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                      {data!.fields.priority.name}
                    </div>
                  </div>
                </div>

                <div className={Styles.column2}>
                  <div className={Styles.row}>
                    <div className={Styles.tableLabel}>Labels</div>
                    <div className={Styles.value}>
                      {/* TODO: Fix this the next time the file is edited. */}
                      {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                      {data!.fields.labels.length !== 0
                        ? // TODO: Fix this the next time the file is edited.
                          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                          data!.fields.labels.map((label) => (
                            <div key={label} className={Styles.issueLabel}>
                              {label}
                            </div>
                          ))
                        : 'None'}
                    </div>
                  </div>

                  <div className={Styles.row}>
                    <div className={Styles.tableLabel}>Due Date</div>
                    <div className={Styles.value}>
                      {/* TODO: Fix this the next time the file is edited. */}
                      {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                      {data!.fields.duedate ? formatWithoutTimezone(data!.fields.duedate) : 'None'}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        )}
      </div>
    </div>
  )
}

const formatWithoutTimezone = (dateString: string) => {
  const date = new Date(dateString)
  const dateWithoutTimezone = new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000)

  return dayjs(dateWithoutTimezone).format('MMMM D, YYYY')
}
